import moment from 'moment';

export default (dashboard) => {
  const startDate = moment(dashboard.dashboardParams.startDate);
  const endDate = moment(dashboard.dashboardParams.endDate);

  const delta = endDate.diff(startDate, 'days');
  const reportCharts = dashboard.report_charts;
  const mapped = [];
  let dateFormat = 'MM/DD/YY';
  let sliceBy = 0;
  if (delta <= 31) {
    sliceBy = 1;
  } else if (delta < 366) {
    sliceBy = 1;
    dateFormat = 'MM/YYYY';
  } else {
    sliceBy = 12;
    dateFormat = 'YYYY';
  }

  let index = 0;
  while (index < reportCharts.length) {
    const group = reportCharts.slice(index, index + sliceBy);
    let totalOpens = 0;
    let totalInterested = 0;
    let totalExpandedInterest = 0;

    for (let i = 0; i < group.length; i += 1) {
      totalOpens += group[i].opened;
      totalInterested += group[i].interested;
      totalExpandedInterest += group[i].expanded_interest;
    }

    mapped.push({
      name: moment.utc(group[0].date).format(dateFormat),
      opened: totalOpens,
      interested: totalInterested,
      expandedInterest: totalExpandedInterest,
    });
    index += sliceBy;
  }
  return mapped;
};
